import { render, staticRenderFns } from "./CyberboardGoldPaisley.vue?vue&type=template&id=60a3e0c5&scoped=true"
import script from "./CyberboardGoldPaisley.vue?vue&type=script&lang=ts"
export * from "./CyberboardGoldPaisley.vue?vue&type=script&lang=ts"
import style0 from "./CyberboardGoldPaisley.vue?vue&type=style&index=0&id=60a3e0c5&prod&lang=scss&scoped=true"
import style1 from "./CyberboardGoldPaisley.vue?vue&type=style&index=1&id=60a3e0c5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a3e0c5",
  null
  
)

export default component.exports